import { GcsPath } from "@/components/common/GcsImage";

/**
 * Defines all public file paths for images stored in Google Cloud Storage (GCS).
 * These constants are used by the <GcsImage /> component and replace the need
 * for static file imports.
 */
export const autoIcon: GcsPath = "icons/Auto-Insurance.webp";
export const bundleIcon: GcsPath = "icons/Bundle-Icon-Transparent.webp";
export const cornerShieldIcon: GcsPath = "icons/Corner-Shield.webp";
export const homeIcon: GcsPath = "icons/Home-Insurance.webp";
export const specialtyIcon: GcsPath = "icons/Specialty-Insurance.webp";
export const investmentPropertiesIcon: GcsPath =
  "icons/investment-properties.webp";
export const homeAutoBundleIcon: GcsPath = "icons/Home & Auto Bundle.webp";
export const umbrellaLiabilityIcon: GcsPath = "icons/liability-insurance.webp";
export const jewelryInsuranceIcon: GcsPath = "icons/jewelry-insurance.webp";
export const boatInsuranceIcon: GcsPath = "icons/boat-insurance.webp";
export const motorcycleInsuranceIcon: GcsPath =
  "icons/motorcycle-insurance.webp";
export const blueStackedLogo: GcsPath = "icons/Blue-Stacked.png";
export const whiteOneLineLogo: GcsPath = "icons/White - One Line.png";
export const utilityIcon: GcsPath = "icons/Utility Line Warranty.png";
export const yellowGreyShieldWithHouse: GcsPath = "icons/Shield with House.png";
export const yellowShieldWithHouse: GcsPath =
  "icons/Yellow and White - Shield and House.png";
export const yellowAndWhiteStackedLogo: GcsPath =
  "icons/Yellow and White - Stacked.png";
export const checkIcon: GcsPath = "icons/check-circle-yellow.png";
export const clockIcon: GcsPath = "icons/icon-clock-2.webp";
export const computerIcon: GcsPath = "icons/icon-computer-2.webp";
export const customizationIcon: GcsPath = "icons/icon-customization.webp";
export const thumbsUpIcon: GcsPath = "icons/thumbs-up-yellow.png";
export const aigLogo: GcsPath = "images/AIG_Logo-2.webp";
export const allstateLogo: GcsPath = "images/Allstate_Logo.webp";
export const amwinsLogo: GcsPath = "images/Amwins_Logo.webp";
export const arbourLogo: GcsPath = "images/Arbour_Insurance_Logo.webp";
export const bbbBadge: GcsPath = "images/BBB_Badge.webp";
export const crcGroupLogo: GcsPath = "images/CRC_Group_Logo.webp";
export const chubbLogo: GcsPath = "images/Chubb_Logo.webp";
export const consumerAffairsLogo: GcsPath = "images/Consumer_Affairs_Logo.webp";
export const estelle: GcsPath = "images/Estelle.webp";
export const farmersLogo: GcsPath = "images/Farmers_Insurance_Logo.webp";
export const fingerprint: GcsPath = "images/Fingerprint.webp";
export const foremostLogo: GcsPath = "images/Foremost_Logo.webp";
export const frontlineLogo: GcsPath = "images/Frontline_Insurance_Logo.webp";
export const googleLogo: GcsPath = "images/Google_Logo.webp";
export const googleReviewsBadge: GcsPath = "images/Google_Reviews_Badge.webp";
export const hagertyLogo: GcsPath = "images/Hagerty_Insurance_Logo.webp";
export const heathFamily: GcsPath = "images/Heath-and-Family-full.webp";
export const heritageLogo: GcsPath = "images/Heritage_Insurance_Logo.webp";
export const homeownersAmericaLogo: GcsPath =
  "images/Homeowners_of_America_Logo.webp";
export const jewelersMutualLogo: GcsPath = "images/Jewelers_Mutual_Logo.webp";
export const johnsonAndJohnsonLogo: GcsPath =
  "images/Johnson_and_Johnson_Logo.webp";
export const karaGrant: GcsPath = "images/Kara-and-Grant-full.webp";
export const karaAtOberlinEvent: GcsPath = "images/kara-event.webp";
export const lemonadeLogo: GcsPath = "images/Lemonade_Logo.webp";
export const libertyMutualLogo: GcsPath = "images/Liberty_Mutual_Logo.webp";
export const nationalGeneralLogo: GcsPath = "images/National_General_Logo.webp";
export const nationwideLogo: GcsPath = "images/Nationwide_Logo.webp";
export const neptuneLogo: GcsPath = "images/Neptune_Insurance_Logo.webp";
export const heroImage: GcsPath =
  "images/New Hero Image for How It Works page.webp";
export const newsweekLogo: GcsPath = "images/Newsweek_Logo.webp";
export const orchidLogo: GcsPath = "images/Orchid_Insurance_Logo.webp";
export const orionLogo: GcsPath = "images/Orion_Logo.webp";
export const palomarLogo: GcsPath = "images/Palomar_Insurance_Logo.webp";
export const peterFamily: GcsPath = "images/Peter-and-family-full.webp";
export const phoneScreen: GcsPath = "images/Phone Screen - for full-width.webp";
export const progressiveLogo: GcsPath = "images/Progressive_Logo.webp";
export const aaaLogo: GcsPath = "images/AAA_Insurance_Logo.webp";
export const pureLogo: GcsPath = "images/Pure_Insurance_Logo.webp";
export const realtorLogo: GcsPath = "images/Realtor_Logo.webp";
export const safecoLogo: GcsPath = "images/Safeco_Insurance_Logo.webp";
export const steadilyLogo: GcsPath = "images/Steadily_Logo.webp";
export const stillwaterLogo: GcsPath = "images/Stillwater_Logo.webp";
export const theHartfordLogo: GcsPath = "images/The_Hartford_Logo-2.webp";
export const theHartfordLogoPng: GcsPath = "images/The_Hartford_Logo.png";
export const travelersLogo: GcsPath = "images/Travelers_Logo.webp";
export const trustpilotBadge: GcsPath = "images/TrustPilot_Badge.webp";
export const trustpilotLogo: GcsPath = "images/TrustPilot_Logo.webp";
export const trustpilotExcellent: GcsPath = "images/trustpilot-excellent.webp";
export const trustpilotMobile: GcsPath = "images/trustpilot-mobile.webp";
export const googleFiveStarsColor: GcsPath = "images/Google 5 Stars - color.webp";
export const googleFiveStarsWhite: GcsPath = "images/Google 5 Stars - white.webp";
export const usaTodayLogo: GcsPath = "images/USA_Today_Logo.webp";
export const universalLogo: GcsPath = "images/Universal_Insurance_Logo-2.webp";
export const wralInterview: GcsPath = "images/WRAL-interview.webp";
export const kristiOnVideo: GcsPath = "images/Kristi_on_Video.webp";
export const washingtonPostLogo: GcsPath = "images/Washington_Post_Logo.webp";
export const geicoLogo: GcsPath = "images/Geico_Logo.webp";
export const theGeneralLogo: GcsPath = "images/The_General_Logo.webp";
export const dairyLandInsuranceLogo: GcsPath =
  "images/Dairyland_Insurance.webp";
export const sageSureLogo: GcsPath = "images/SageSure_Logo.webp";
export const savviLogo: GcsPath = "images/Savvi_Logo.webp";
export const swyfftLogo: GcsPath = "images/Swyfft_Logo.webp";
export const rootInsuranceLogo: GcsPath = "images/Root_Insurance_Logo.webp";
export const americanModernLogo: GcsPath = "images/American_Modern_Logo.webp";
export const bambooInsuranceLogo: GcsPath = "images/Bamboo_Insurance_Logo.webp";
export const alliedTrustLogo: GcsPath = "images/Allied_Trust_Logo.webp";
export const branchLogo: GcsPath = "images/Branch_Logo.webp";
export const clearcoverLogo: GcsPath = "images/Clearcover_Logo.webp";
export const mutualOfEnumclawLogo: GcsPath = "images/Mutual_of_Enumclaw_Logo.webp";
export const plymouthRockLogo: GcsPath = "images/Plymouth_Rock_Assurance_Logo.webp";
export const pennNationalLogo: GcsPath = "images/Penn_National_Logo.webp";
export const westBendLogo: GcsPath = "images/West_Bend_Logo.webp";
export const mapfreLogo: GcsPath = "images/Mapfre_Insurance_Logo.webp";
export const mercuryInsuranceLogo: GcsPath = "images/Mercury_Insurance_Logo.webp";
export const grangeLogo: GcsPath = "images/Grange_Insurance_Logo.webp";
export const obieLogo: GcsPath = "images/Obie_Logo.webp";
export const geoVeraLogo: GcsPath = "images/GeoVera_Logo.webp";
export const shelterLogo: GcsPath = "images/Shelter_Insurance_Logo.webp";
export const bearRiverMutualLogo: GcsPath = "images/Bear_River_Mutual_Logo.webp";
export const westfieldLogo: GcsPath = "images/Westfield_Logo.webp";
export const wellingtonLogo: GcsPath = "images/Wellington_Logo.webp";
export const oneAllianceLogo: GcsPath = "images/One_Alliance_Logo.webp";
export const twiaLogo: GcsPath = "images/TWIA_Logo.webp";
export const americanIntegrityLogo: GcsPath = "images/American_Integrity_Logo.webp";
export const aboutHeroImage: GcsPath = "images/about/about-hero-new-2.webp";
export const aboutHeroNewImage: GcsPath = "images/about/about-hero-new-5.webp";
export const aboutPhoto1: GcsPath = "images/about/about-photo-1.webp";
export const aboutPhoto2: GcsPath = "images/about/about-photo-2.webp";
export const aboutPhoto3: GcsPath = "images/about/about-photo-3.webp";
export const customerEstelle: GcsPath = "images/about/customer-estelle.webp";
export const customerEstelleNew: GcsPath =
  "images/about/customer-estelle-new.webp";
export const customerHeath: GcsPath = "images/about/customer-heath-family.webp";
export const customerKara: GcsPath = "images/about/customer-kara-family.webp";
export const customerMichaelFamily: GcsPath =
  "images/about/customer-michael-family.webp";
export const customerSonticeFamily: GcsPath =
  "images/about/customer-sontice-family.webp";
export const arrowYellow: GcsPath = "images/arrow-yellow.webp";
export const autoInsurance: GcsPath = "images/auto-insurance-panorama.webp";
export const calendarConvenienceBg: GcsPath =
  "images/calendar-convenience-bg.webp";
export const callForwardGiftCard: GcsPath =
  "images/call-forward/AMZ_Gift_Card-2.webp";
export const callForwardGiftCardIcon: GcsPath =
  "images/call-forward/Gift_Card_Icon-2.webp";
export const callForwardHero: GcsPath =
  "images/call-forward/MMM_Call_Hero_Image.webp";
export const callForwardPhoneIcon: GcsPath =
  "images/call-forward/Phone_Icon.webp";
export const callForwardComparisonIcon: GcsPath =
  "images/call-forward/Step_2_Icon_-_thicker.webp";
export const carImage1: GcsPath = "images/car-image-1.webp";
export const carImage2: GcsPath = "images/car-image-2.webp";
export const carImage3: GcsPath = "images/car-image-3.webp";
export const checkCircleBlue: GcsPath = "images/check-circle-blue-icon.webp";
export const choiceSectionBg: GcsPath = "images/choice-section-bg.webp";
export const cornerShield: GcsPath = "images/corner-shield.webp";
export const girlWithCap: GcsPath = "images/girl-with-cap.webp";
export const inviteHeroWelcomeMat: GcsPath =
  "images/invite-hero-welcome-mat.webp";
export const inviteHiw1: GcsPath = "images/invite-hiw1.webp";
export const inviteHiw2: GcsPath = "images/invite-hiw2.webp";
export const inviteHiw3: GcsPath = "images/invite-hiw3.webp";
export const inviteValueShieldCheckmarkBlue: GcsPath =
  "images/invite-value-shield-checkmark-blue.webp";
export const inviteMemberBenefitsHouseLine: GcsPath =
  "images/invite-member-benefits-house-line.webp";
export const inviteFinalCtaShieldGray: GcsPath =
  "images/invite-final-cta-shield-gray.webp";
export const heroAutoInsurance: GcsPath = "images/hero-auto-insurance-v2.webp";
export const heroHomeInsurance: GcsPath = "images/hero-home-insurance-v3.webp";
export const heroUtilityLine: GcsPath =
  "images/hero-utility-line-warranty.webp";
export const heroUmbrellaInsurance: GcsPath = "images/umbrella-hero.webp";
export const heroJewelryInsurance: GcsPath = "images/jewelry-hero.webp";
export const jewelryPageWideBanner: GcsPath =
  "images/jewelry-insurance-banner.webp";
export const umbrellaInsuranceBanner: GcsPath =
  "images/umbrella-insurance-banner.webp";
export const heroBgLightBlue: GcsPath =
  "images/shop-rates/hero-bg-light-blue-gradient.webp";
export const hiw1: GcsPath = "images/hiw1.webp";
export const hiw2: GcsPath = "images/how-it-works-we-shop.webp";
export const hiw3: GcsPath = "images/hiw3.webp";
export const homeBlock1: GcsPath = "images/home-block-1-new.webp";
export const homeBlock2: GcsPath = "images/home-block-2-new.webp";
export const homeBlock3: GcsPath = "images/home-block-3-updated.webp";
export const homeReview1: GcsPath = "images/home-review-new-1.webp";
export const homeReview10: GcsPath = "images/home-review-new-10.webp";
export const homeReview2: GcsPath = "images/home-review-new-2.webp";
export const homeReview3: GcsPath = "images/home-review-new-3.webp";
export const homeReview4: GcsPath = "images/home-review-new-4.webp";
export const homeReview5: GcsPath = "images/home-review-new-5.webp";
export const homeReview6: GcsPath = "images/home-review-new-6.webp";
export const homeReview7: GcsPath = "images/home-review-new-7.webp";
export const homeReview8: GcsPath = "images/home-review-new-8.webp";
export const homeReview9: GcsPath = "images/home-review-new-9.webp";
export const getCoveredIcon: GcsPath = "images/icon-get-covered.webp";
export const repairsDoneIcon: GcsPath = "images/icon-repairs-done.webp";
export const submitClaimIcon: GcsPath = "images/icon-submit-claim.webp";
export const heroSpecialtyInsurance: GcsPath =
  "images/insurance/hero-specialty-insurance.webp";
export const rowOfHouses: GcsPath = "images/row-of-houses-fullwidth.webp";
export const specialtyBoat: GcsPath = "images/specialty-boat.webp";
export const specialtyCondo: GcsPath = "images/specialty-condo.webp";
export const specialtyMotorcycle: GcsPath = "images/specialty-motorcycle.webp";
export const specialtyRv: GcsPath = "images/specialty-rv-fullwidth.webp";
export const stackOfCash: GcsPath = "images/stack-of-cash.webp";
export const testimonialHeadshotAllenFoster: GcsPath =
  "images/testimonial-headshot-allen-foster.webp";
export const testimonialHeadshotKylePatterson: GcsPath =
  "images/testimonial-headshot-kyle-patterson.webp";
export const testimonialHeadshotLaurenProsser: GcsPath =
  "images/testimonial-headshot-lauren-prosser.webp";
export const testimonialHeadshotMollyOConnor: GcsPath =
  "images/testimonial-headshot-molly-oconnor.webp";
export const testimonialPhotoAllenFoster: GcsPath =
  "images/testimonial-photo-allen-foster.webp";
export const testimonialPhotoKylePatterson: GcsPath =
  "images/testimonial-photo-kyle-patterson.webp";
export const testimonialPhotoLaurenProsser: GcsPath =
  "images/testimonial-photo-lauren-prosser.webp";
export const testimonialPhotoMollyOConnor: GcsPath =
  "images/testimonial-photo-molly-oconnor.webp";
export const testimonialDebbie: GcsPath = "images/testimonial-Debbie.webp";
export const testimonialMichael: GcsPath = "images/testimonial-michael.webp";
export const testimonialSontice: GcsPath = "images/testimonial-sontice.webp";
export const testimonialEstelleOriginal: GcsPath =
  "images/Estelle-original.webp";
export const ulwClogsBlockages: GcsPath = "images/ulw-clogs-blockages.webp";
export const ulwFeatureBlock: GcsPath = "images/ulw-feature-block-3.webp";
export const ulwGroundSettling: GcsPath = "images/ulw-ground-settling.webp";
export const ulwInfographic: GcsPath = "images/ulw-infographic.webp";
export const ulwLocalProfessionals: GcsPath =
  "images/ulw-local-professionals.webp";
export const ulwNationalExpertise: GcsPath =
  "images/ulw-national-expertise.webp";
export const ulwOldPipes: GcsPath = "images/ulw-old-pipes.webp";
export const ulwResponsiveService: GcsPath =
  "images/ulw-responsive-service.webp";
export const ulwRodents: GcsPath = "images/ulw-rodents.webp";
export const ulwTreeRoots: GcsPath = "images/ulw-tree-roots.webp";
export const ulwWeatherConditions: GcsPath =
  "images/ulw-weather-conditions.webp";
export const underline: GcsPath = "images/underline-2.webp";
export const underlineNavy: GcsPath = "images/underline-navy.webp";
export const underlineWhite: GcsPath = "images/underline-white.webp";
export const whiteShield: GcsPath = "images/white-shield.webp";
export const marketplaceReshopping: GcsPath =
  "images/marketplace-reshopping.webp";
export const customerEstelleImage: GcsPath = "images/customer-estelle.webp";
export const locationPinBlue: GcsPath = "images/location-pin-blue.webp";
export const homeIllustrationShield: GcsPath =
  "images/home-illustration-shield.webp";
export const testimonialAndreaTysor: GcsPath =
  "images/careers/testimonial-andrea-tysor.webp";
export const testimonialAnthony: GcsPath =
  "images/careers/testimonial-anthony-spinasanto.webp";
export const testimonialJeremy: GcsPath =
  "images/careers/testimonial-jeremy-lifestyle.webp";
export const testimonialLaura: GcsPath =
  "images/careers/testimonial-laura-lifestyle.webp";
export const testimonialNate: GcsPath =
  "images/careers/testimonial-nate-brown.webp";
export const testimonialEric: GcsPath =
  "images/careers/testimonial-eric-bushey.webp";
export const testimonialTyson: GcsPath =
  "images/careers/testimonial-tyson-lifestyle.webp";
export const testimonialKatie: GcsPath = "images/testimonial-katie-rhode.webp";
export const testimonialThomasMcLaughlin: GcsPath =
  "images/Testimonial Photo - Thomas McLaughlin.webp";
export const testimonialDianeMarrero: GcsPath =
  "images/Testimonial Photo - Diane Marrero.webp";
export const testimonialJorgeOrtiz: GcsPath =
  "images/careers/testimonial-jorge-ortiz.webp";
export const testimonialTessaB: GcsPath =
  "images/careers/testimonial-tessa-b.webp";
export const testimonialElizabethBunn: GcsPath =
  "images/about/testimonial-elizabeth-bunn.webp";
export const testimonialSethGarff: GcsPath =
  "images/about/testimonial-seth-garff.webp";
export const testimonialLukeMitchell: GcsPath =
  "images/about/testimonial-luke-mitchell.webp";
export const testimonialKaraCredle: GcsPath =
  "images/about/testimonial-kara-credle.webp";
export const testimonialLaurenSchwenk: GcsPath =
  "images/about/testimonial-lauren-schwenk.webp";
export const meetOurAgents: GcsPath = "images/careers/meet-our-agents-new.webp";
export const iconServeOthers: GcsPath = "icons/icon-serve-others.webp";
export const iconExpectExcellence: GcsPath =
  "icons/icon-expect-excellence.webp";
export const iconReachForResults: GcsPath = "icons/icon-reach-for-results.webp";
export const iconValueGrowth: GcsPath = "icons/icon-value-growth.webp";
export const iconEnergizeEngage: GcsPath = "icons/icon-energize-engage.webp";
export const slideshow2: GcsPath = "images/life-slideshow-new-2.webp";
export const slideshow3: GcsPath = "images/life-slideshow-new-3.webp";
export const slideshow4: GcsPath = "images/life-slideshow-new-4.webp";
export const slideshow5: GcsPath = "images/life-slideshow-new-5.webp";
export const slideshow6: GcsPath = "images/life-slideshow-new-6.webp";
export const slideshow7: GcsPath = "images/life-slideshow-new-7.webp";
export const slideshow8: GcsPath = "images/life-slideshow-new-8.webp";
export const slideshow9: GcsPath = "images/life-slideshow-new-9.webp";
export const slideshow10: GcsPath = "images/life-slideshow-new-10.webp";
export const slideshow11: GcsPath = "images/life-slideshow-new-11.webp";
export const slideshow12: GcsPath = "images/life-slideshow-new-12.webp";
export const slideshow13: GcsPath = "images/life-slideshow-new-13.webp";
export const slideshow14: GcsPath = "images/life-slideshow-new-14.webp";
export const slideshow15: GcsPath = "images/life-slideshow-new-15.webp";
export const slideshow16: GcsPath = "images/life-slideshow-new-16.webp";
export const slideshow17: GcsPath = "images/life-slideshow-new-17.webp";
export const slideshow18: GcsPath = "images/life-slideshow-new-18.webp";
export const slideshow19: GcsPath = "images/life-slideshow-new-19.webp";
export const slideshow20: GcsPath = "images/life-slideshow-new-20.webp";
export const slideshow21: GcsPath = "images/life-slideshow-new-21.webp";
export const slideshow22: GcsPath = "images/life-slideshow-new-22.webp";
export const slideshow23: GcsPath = "images/life-slideshow-new-23.webp";
export const slideshow24: GcsPath = "images/life-slideshow-new-24.webp";
export const slideshow25: GcsPath = "images/life-slideshow-new-25.webp";
export const servingAgents1: GcsPath = "images/flipping-pyramid-v2.webp";
export const servingAgents2: GcsPath = "images/frontline-mindset-new.webp";
export const servingAgents3: GcsPath = "images/frontline-mindset.webp";
export const communityNonprofit: GcsPath =
  "images/nonprofit-board-leadership.webp";
export const communityBuilding: GcsPath = "images/building-home-habitat.webp";
export const communityDonations: GcsPath = "images/matching-employees.webp";
export const communityConnections: GcsPath = "images/kara-event.webp";
export const monitorImg: GcsPath = "images/about/monitor.webp";
export const thankYouShieldCheckmark: GcsPath = "icons/Shield with Checkmark.png";
export const thankYouMarketplaceScreenshot: GcsPath =
  "icons/Guardian Marketplace Screenshot.webp";
export const nextStepsAndreaTysor: GcsPath =
  "images/next-steps-andrea-tysor.webp";
export const nextStepsThomasMcLaughlin: GcsPath =
  "images/next-steps-thomas-mclaughlin.webp";
export const nextStepsKatieRohde: GcsPath = "images/next-steps-katie-rohde.webp";
export const andreaAvatar: GcsPath = "images/careers/andrea-avatar-new.webp";
export const jeremyAvatar: GcsPath = "images/careers/jeremy-avatar-new.webp";
export const kristiAvatar: GcsPath = "images/careers/kristi-avatar-new.webp";
export const kristiWorkingImg: GcsPath = "images/about/kristi-working.webp";
export const secureIcon: GcsPath = "icons/secure.webp";
export const bbbGreyIcon: GcsPath = "icons/bbb-grey.webp";
export const heroCheapHome: GcsPath = "images/hero-cheap-home.webp";
export const kristiCtaPhoto: GcsPath = "images/about/kristi-cta-photo.webp";
export const whereWeServeHero: GcsPath =
  "images/about/where-we-serve-hero.webp";
export const corkBoardWallPhoto: GcsPath = "images/cork-board-wall-photo.webp";
export const howItWorksHeroNew: GcsPath = "images/how-it-works-hero-new.webp";
export const kyshawnGsPoloDesktop: GcsPath =
  "images/kyshawn_gs_polo_desktop.webp";
export const kyshawnGsPoloMobile: GcsPath =
  "images/kyshawn_gs_polo_mobile.webp";

/**
 * Supported states for marketing pages with flag assets
 */
const STATES_WITH_FLAGS = [
  "AL",
  "AZ",
  "CO",
  "CT",
  "GA",
  "IN",
  "KY",
  "MD",
  "MN",
  "MO",
  "MS",
  "NC",
  "NJ",
  "NM",
  "NV",
  "OH",
  "OR",
  "PA",
  "SC",
  "TN",
  "TX",
  "UT",
  "VA",
  "WA",
] as const;
type StateFlagAbbr = (typeof STATES_WITH_FLAGS)[number];

/**
 * Get the desktop hero flag path for a state
 * @param stateAbbr - Two-letter state abbreviation (e.g., "NC", "GA")
 * @returns GcsPath for the state's desktop flag
 * @throws Error if state flag doesn't exist
 */
export function getStateFlagHero(stateAbbr: string): GcsPath {
  const normalized = stateAbbr.toUpperCase();

  if (!STATES_WITH_FLAGS.includes(normalized as StateFlagAbbr)) {
    throw new Error(
      `No flag asset available for state: ${stateAbbr}. ` +
        `Supported states: ${STATES_WITH_FLAGS.join(", ")}`,
    );
  }

  return `images/flags/${normalized.toLowerCase()}-flag-hero.webp` as GcsPath;
}

/**
 * Get the mobile hero flag path for a state
 * @param stateAbbr - Two-letter state abbreviation (e.g., "NC", "GA")
 * @returns GcsPath for the state's mobile flag
 * @throws Error if state flag doesn't exist
 */
export function getStateFlagHeroMobile(stateAbbr: string): GcsPath {
  const normalized = stateAbbr.toUpperCase();

  if (!STATES_WITH_FLAGS.includes(normalized as StateFlagAbbr)) {
    throw new Error(
      `No mobile flag asset available for state: ${stateAbbr}. ` +
        `Supported states: ${STATES_WITH_FLAGS.join(", ")}`,
    );
  }

  return `images/flags/${normalized.toLowerCase()}-flag-hero-mobile.webp` as GcsPath;
}
